import { SortingState } from "@tanstack/react-table";
import snakeCase from "lodash/snakeCase";

export const parseSorting = (sorting: SortingState) => ({
  direction: sorting[0]?.desc ? "desc" : "asc",
  name: sorting[0]?.id ? snakeCase(sorting[0].id) : undefined
});
